import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../../api/api';
import Cookies from 'universal-cookie';

const cookies = new Cookies();

export const socialApi = createApi({
  reducerPath: 'socialApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Social'],
  endpoints: (builder) => ({
    // Get social media data from user-info endpoint
    getSocialData: builder.query({
      query: (userId) => {
        const token = cookies.get('authToken');
        return {
          url: 'api/web/v1/site/user-info',
          method: 'POST',
          params: { 'access-token': token, id: userId },
        };
      },
      transformResponse: (response) => {
        if (response?.status === 1) {
          const userData = response.data?.[0] || {};
          // Extract social media fields from user data
          return {
            facebook: userData.facebook || '',
            x: userData.x || '',
            snap: userData.snap || '',
            insta: userData.insta || '',
            whats: userData.whats || '',
            tiktok: userData.tiktok || '',
            linked: userData.linked || '',
            phone: userData.phone || '',
            mobile: userData.mobile || '',
            youtube: userData.youtube || '',
            email: userData.email || '',
          };
        }
        return {
          facebook: '',
          x: '',
          snap: '',
          insta: '',
          whats: '',
          tiktok: '',
          linked: '',
          phone: '',
          mobile: '',
          youtube: '',
          email: '',
        };
      },
      providesTags: ['Social'],
    }),
    // Update social media data using profile endpoint
    updateSocial: builder.mutation({
      query: (socialData) => {
        const token = cookies.get('authToken');
        const formData = new FormData();
        
        // Append all social media data to FormData with the exact field names
        formData.append('facebook', socialData.facebook || '');
        formData.append('x', socialData.x || '');
        formData.append('snap', socialData.snap || '');
        formData.append('insta', socialData.insta || '');
        formData.append('whats', socialData.whats || '');
        formData.append('tiktok', socialData.tiktok || '');
        formData.append('linked', socialData.linked || '');
        formData.append('phone', socialData.phone || '');
        formData.append('mobile', socialData.mobile || '');
        formData.append('youtube', socialData.youtube || '');
        if (socialData.email) {
          formData.append('email', socialData.email || '');
        }
        
        return {
          url: 'api/web/v1/site/update-socail',
          method: 'POST',
          data: formData,
          params: { 'access-token': token },
          isFormData: true,
        };
      },
      transformResponse: (response) => {
        // Return the full response so component can check status
        console.log('Update API response:', response);
        return response;
      },
      invalidatesTags: ['Social'],
    }),
  }),
});

export const {
  useGetSocialDataQuery,
  useUpdateSocialMutation,
} = socialApi;